import React from "react";
import PropTypes from "prop-types";
import { Dots  } from '@zendeskgarden/react-loaders';
import { getColor } from '@zendeskgarden/react-theming'
import styled, { useTheme } from "styled-components";

const Container = styled('div')`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 20;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255,255,255,0.6);
  
`;


const SpinnerOverlay = ({ display }) => {
  const theme = useTheme();

  return (
    <Container>
      <Dots size={36} duration={1250} color={theme.colors.primary} />
    </Container>
  );
};

SpinnerOverlay.propTypes = {

};

export default SpinnerOverlay;
